import { IntlProvider, type MessageFormatElement } from 'react-intl';

import { VitaDocumentLanguage } from '@xing-com/crate-common-graphql-types';
import {
  useReadVitaReactiveVariable,
  useReadCoverLetter,
  useIsCoverLetterEditor,
} from '@xing-com/crate-lebenslauf-hooks';

export type Translations = {
  DE: {
    messages: Record<string, MessageFormatElement[]>;
  };
  EN: {
    messages: Record<string, MessageFormatElement[]>;
  };
};

type VitaDocumentLanguageProviderProps = {
  children: React.ReactNode;
  translations: Translations;
};

export const VitaDocumentLanguageProvider: React.FC<
  VitaDocumentLanguageProviderProps
> = ({ children, translations }) => {
  const { language } = useReadVitaReactiveVariable();
  const coverLetter = useReadCoverLetter();
  const isCoverLetterEditor = useIsCoverLetterEditor();
  const currentLanguage = isCoverLetterEditor
    ? coverLetter?.language
    : language;

  return (
    <IntlProvider
      messages={translations[currentLanguage || 'DE'].messages}
      locale={currentLanguage === VitaDocumentLanguage.En ? 'en' : 'de'}
    >
      {children}
    </IntlProvider>
  );
};
